module.exports = __webpack_public_path__ + "static/media/chatting.d960bbc5.png";